import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import api from "@/lib/api";

export default function IndustryPage() {
    const { slug } = useParams();
    const [industry, setIndustry] = useState(null);
    const [products, setProducts] = useState([]);
    useEffect(() => {
        Promise.all([api.get("/industries"), api.get("/products")]).then(([i, p]) => {
            setIndustry(i.data.industries.find((x) => x.slug === slug));
            setProducts(p.data.products);
        });
    }, [slug]);

    if (!industry) return <div className="pt-40 text-center text-slate-500">Loading…</div>;
    const related = products.filter((p) => industry.products?.includes(p.slug));

    return (
        <main data-testid={`industry-page-${slug}`} className="pt-[72px]">
            <section className="bg-[#0B1930] text-white pt-24 pb-24 relative overflow-hidden grain">
                <div className="hero-glow top-[-30%] left-[10%]" style={{ background: "#2563EB" }} />
                <div className="max-w-[1400px] mx-auto px-6 lg:px-10 relative">
                    <div className="eyebrow">Industry Solution</div>
                    <h1 className="headline text-5xl md:text-6xl lg:text-7xl mt-6 max-w-4xl">{industry.name}</h1>
                    <p className="text-white/70 text-lg mt-6 max-w-2xl">{industry.summary}</p>
                </div>
            </section>
            <section className="py-20 max-w-[1400px] mx-auto px-6 lg:px-10">
                <h2 className="eyebrow eyebrow--slate">Recommended Colecle Products</h2>
                <div className="grid md:grid-cols-2 gap-5 mt-8">
                    {related.map((p) => (
                        <Link key={p.slug} to={`/products/${p.slug}`} className="bg-white border border-slate-200 rounded-2xl p-8 hover:border-navy transition group flex items-start justify-between gap-5">
                            <div>
                                <div className="eyebrow">{p.tagline}</div>
                                <h3 className="font-serif text-2xl text-navy mt-3">{p.name}</h3>
                                <p className="text-slate-600 text-sm mt-2 leading-relaxed">{p.short_description}</p>
                            </div>
                            <ArrowUpRight className="w-5 h-5 text-slate-400 group-hover:text-[#E8B923] transition flex-shrink-0" />
                        </Link>
                    ))}
                </div>
                <div className="mt-16">
                    <Link to="/request-demo" className="btn-gold">Request a Tailored Demo <ArrowUpRight className="w-4 h-4" /></Link>
                </div>
            </section>
        </main>
    );
}
